module.exports = __webpack_public_path__ + "static/media/OctopusBit.28db9288.png";